import React from "react";

const AdminBadge = () => (
    <div style={{ backgroundColor: '#6528d8', padding: '2px 8px', borderRadius: '12px' }}>
        <span style={{ color: 'white', fontSize: '12px' }} >
            CREATOR
        </span>
    </div >
);


export default AdminBadge
